export const YEAR_MONTH_DAY_FORMAT = 'yyyy-MM-dd';
export const MONTH_DAY_YEAR_SLASHED_FORMAT = 'MM/dd/yyyy';
export const SHORT_MONTH_DAY_YEAR_SLASHED_FORMAT = 'M/d/yyyy';
export const MONTH_DAY_YEAR_COMPACT_FORMAT = 'MMddyyyy';
export const SHORT_MONTH_DAY_YEAR_COMPACT_FORMAT = 'Mddyyyy';

export const ALL_DATE_FORMATS = [
  YEAR_MONTH_DAY_FORMAT,
  MONTH_DAY_YEAR_SLASHED_FORMAT,
  SHORT_MONTH_DAY_YEAR_SLASHED_FORMAT,
  MONTH_DAY_YEAR_COMPACT_FORMAT,
  SHORT_MONTH_DAY_YEAR_COMPACT_FORMAT,
];
